import React from "react";

interface SpinnerLoaderProps {
	size?: number;
	color?: string;
	thickness?: number;
	speed?: number;
}

const SpinnerLoader: React.FC<SpinnerLoaderProps> = ({ size = 40, color = "#3b82f6", thickness = 4, speed = 0.75 }) => {
	return (
		<div className="inline-block" role="status" aria-label="loading">
			<svg
				className={`animate-spin`}
				style={{
					width: `${size}px`,
					height: `${size}px`,
					animationDuration: `${speed}s`,
				}}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<circle className="opacity-25" cx="12" cy="12" r="10" stroke={color} strokeWidth={thickness}></circle>
				<path
					className="opacity-75"
					fill={color}
					d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
				></path>
			</svg>
		</div>
	);
};

export default SpinnerLoader;
